






























import Vue from 'vue';
import { datetimeFormatToAmericanFormat, formatPrice } from '../../lib/utils';

function sortPaymentsByDate(payments: any) {
    return payments.sort((a: any, b: any) => (new Date(`${a.transaction_time}`) > new Date(`${b.transaction_time}`) ? -1 : 1));
}

export default Vue.extend({
    props: {
        userId: {
            required: true,
            type: Number,
        },
        dateRange: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            userPayments: [],
            selectedPayment: {},
            refundData: {},
            isRefundOn: true,
            loading: false,
            headers: [
                {
                    text: 'Transaction time', value: 'transaction_timeWithTzUser', width: 160, sortable: false,
                },
                {
                    text: 'Total Amount', value: 'amount', width: 135, sortable: false,
                },
                {
                    text: 'Charge Amount', value: 'payment_charge_amount', width: 130, sortable: false,
                },
                {
                    text: 'Charge Refund', value: 'refund_amount', width: 135, sortable: false,
                },
                {
                    text: 'Discount Amount', value: 'discount_amount', width: 139, sortable: false,
                },
                {
                    text: 'Credit Amount', value: 'credit_amount', width: 135, sortable: false,
                },
                {
                    text: 'Credit Refund', value: 'credit_refund', width: 135, sortable: false,
                },
                {
                    text: 'Status', value: 'status', width: 100, sortable: false,
                },
                {
                    text: 'Description', value: 'description', width: 140, sortable: false,
                },
                {
                    text: 'Card Brand', value: 'brand', width: 105, sortable: false,
                },
                {
                    text: 'last4', value: 'last4', width: 100, sortable: false,
                },
            ],
        };
    },
    methods: {
        formatPrice,
        datetimeFormatToAmericanFormat,
        getUserPayments() {

            if (this.dateRange.length === 2 && this.userId && this.userId > 0) {
                this.loading = true;
                this.$hipApi.getUserPayments(this.userId, this.dateRange[0] as string, this.dateRange[1] as string)
                    .then((response) => {
                        this.userPayments = sortPaymentsByDate(response);
                    })
                    .catch((err) => {
                        this.$notifier.showError(err?.error?.message || err?.message || err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    watch: {
        dateRange() {
            this.getUserPayments();
        },
    },
    created() {
        this.getUserPayments();
    },
});
